import type { AxiosError } from 'axios'

import type { InterceptorsType } from '@img-arena/consoles-api-dde'
import logger from '@/utils/_legacy/logger'
import { notifyError } from '@/utils/notifyError'

import { logout } from '../authService'
import { HTTP_STATUS_CODE } from '../constants/httpStatusCode'

export const logoutOnUnauthorized: InterceptorsType = {
  responseError: async (error) => {
    const status = (error as AxiosError)?.response?.status

    if (status === HTTP_STATUS_CODE.UNAUTHORIZED) {
      try {
        await logout()
      } catch (error) {
        logger.error(error, 'Logout failed')
        notifyError('An error occurred during logout. Please try again.')
      }
    }

    return error
  }
}
